import React from 'react'
import CustomTable from '../../shared/CustomTable'
import {
  NursingNotesColumns,
} from '../../constants/ProfillingConstants'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

function NursingNote () {
  const { t } = useTranslation()
  const { isLoading, patientDoctorNotes } = useSelector(
    state => state?.notes
  )
  return (
    <div>
      <CustomTable
        isLoading={isLoading}
        columns={NursingNotesColumns(t)}
        data={
          patientDoctorNotes?.data?.nursing_notes?.map(data => ({
            ...data,
            createdAt: data?.created_at,
            updatedAt:data?.updated_at
          })) || []
        }
      />
    </div>
  )
}

export default NursingNote
